import React from 'react'
import { observer } from "mobx-react-lite";
import { ArrowRight } from 'react-bootstrap-icons';
import { useNavigate, useParams } from 'react-router-dom';

export default observer(function CampaignInfluencerSidebarHeader({ auth }) {
  const { id } = useParams()
  const navigate = useNavigate()

  return (
    <div className='flex justify-between p-4'>
      <div className="flex items-center">
        <img src={auth.avatar} className='bg-rb-green border-1 border-grey-500 rounded-full w-8 h-8 mr-2' />
        <span className='text-xl'>{auth.username}</span>
      </div>
      <button
        className='flex gap-1 items-center hover:bg-gray-200 rounded-lg p-2'
        onClick={() => {
          auth.isSelected = false
          navigate(`/advertiser/campaign_share/${id}/influencers`)
        }}
      >
        <span>Back</span>
        <ArrowRight />
      </button>
    </div>
   );
})
